"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sidePane;
var _snackbarActions = require("../actions/snackbarActions");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var initalState = {
  snacks: []
};
function sidePane() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    payload = _ref.payload,
    type = _ref.type;
  var snacks = state.snacks;
  switch (type) {
    case _snackbarActions.ADD_SNACK:
      return {
        snacks: [].concat(_toConsumableArray(snacks), [payload])
      };
    case _snackbarActions.REMOVE_SNACK:
      return {
        snacks: snacks.filter(function (snack) {
          return snack.uniqueId !== payload;
        })
      };
    default:
      return state;
  }
}